import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotificationApiService {
  private baseUrl = environment.baseUrl + 'notification';

  constructor(private http: HttpClient) {}

  findAllForUser(userId: number | string) {
    return this.http.get<any[]>(`${this.baseUrl}/user/${userId}`);
  }

  findAllUnreadForUser(userId: number | string) {
    return this.http.get<any[]>(`${this.baseUrl}/user/unread/${userId}`);
  }

  markRead(id: number | string) {
    return this.http.patch<any>(`${this.baseUrl}/${id}`, {});
  }
}
